const RealestateTypeEnum = {
  VILLA: 1,
  APARTMENT: 2,
  GROUND: 3
}
export default RealestateTypeEnum


// WEBPACK FOOTER //
// ./src/enum/realestateTypeEnum.js